import { getErrorPayload } from '@application/common/helpers/api-helper';
import WorkTypeApi from '@infrastructure/work-type-api';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { addSuccessNotification } from '../common/notificationSlice';
export const getAllWorkTypeAsync = createAsyncThunk('workType/GetAllWorkTypes', async (_, { rejectWithValue }) => {
    try {
        const response = await WorkTypeApi.getAll();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getWorkTypeByIdAsync = createAsyncThunk('workType/GetById', async (workTypeId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await WorkTypeApi.getById(workTypeId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateWorkType = createAsyncThunk('workType/Update', async (request, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await WorkTypeApi.update(request);
        dispatch(addSuccessNotification('werktype succesvol bijgewerkt'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
